module.exports = __webpack_public_path__ + "img/027.51f2a8ea.png";